import React from "react"

import { Input } from "components"
import { productUnitsSymbol } from "constant"
import classes from "./StrmrmRequestedItemCard.module.scss"
import { FaTrashAlt } from "react-icons/fa"

const StrmrmRequestedItemCard = (props) => {
  const {
    requestedItems,
    setRequestedItems,
    selectedFoodOption,
    setSelectedFoodOptions
  } = props

  const handleDelete = () => {
    setSelectedFoodOptions(prev => {
      const newSelectedFoodOptions = { ...prev }

      delete newSelectedFoodOptions[selectedFoodOption.optionId]

      return newSelectedFoodOptions
    })

    setRequestedItems(prev => {
      const newRequestedItems = { ...prev }

      delete newRequestedItems[selectedFoodOption.optionId]

      return newRequestedItems
    })
  }

  const handleChange = (e) => {
    setRequestedItems(prev => {
      const previousRequestedItems = { ...prev }

      previousRequestedItems[selectedFoodOption.optionId] = {
        foodId: selectedFoodOption.foodId,
        optionId: selectedFoodOption.optionId,
        requestedQuantity: e.target.value
      }

      return previousRequestedItems
    })
  }

  const numberType =
    selectedFoodOption.unit === "quantity" ? "int" : "float"

  const requestedQuantity =
    requestedItems[selectedFoodOption.optionId]?.requestedQuantity || ""

  return (
    <tr>
      <td>
        <button
          className={classes["delete"]}
          onClick={handleDelete}
        >
          <FaTrashAlt />
        </button>
      </td>
      <td>
        {selectedFoodOption.foodName}{" "}
        {selectedFoodOption.isSimple ? "" : selectedFoodOption.foodOptionName}
      </td>
      <td>
        <div className={classes["input-container"]}>
          <Input
            min={0}
            type="number"
            value={requestedQuantity}
            numberType={numberType}
            onChange={handleChange}
            className={classes["input"]}
          />
          <span>
            {productUnitsSymbol[selectedFoodOption.unit]}
          </span>
        </div>
      </td>
    </tr>
  )
}

export default StrmrmRequestedItemCard